export const agentPlayground = {
  header: {
    title: "Testowanie agenta AI",
    chip: "Recepcja AI · Beta",
    sub: "Porozmawiaj z zaawansowanym agentem bez wysyłania czegokolwiek przez WhatsApp.",
  },
  context: {
    title: "Kontekst",
    listingLabel: "Oferta",
    listingPlaceholder: "Wybierz ofertę…",
    allListings: "🌐 Wszystkie obiekty (nowe rezerwacje)",
    accountModeHint:
      "Agent odpowiada tak, jakby nie był przypisany do konkretnego obiektu: idealne do testowania zapytań o rezerwację.",
    guestStatusLabel: "Status gościa",
    stay: {
      auto: "Automatycznie",
      inStay: "Obecnie przebywa (w trakcie pobytu)",
      beforeArrival: "Jeszcze nie przyjechał (przyszła rezerwacja)",
      after: "Pobyt zakończony",
    },
    guestStatusHint: "Zasymuluj moment pobytu gościa, aby zobaczyć różne odpowiedzi.",
    reservationIdLabel: "ID rezerwacji",
    optional: "(opcjonalnie)",
    reservationIdPlaceholder: "np. 1234",
    phoneLabel: "Telefon gościa",
    phonePlaceholder: "+34...",
    langLabel: "Język",
    lang: {
      auto: "Automatycznie",
      es: "Hiszpański",
      en: "Angielski",
      pt: "Portugalski",
      fr: "Francuski",
      de: "Niemiecki",
      pl: "Polski",
    },
    reset: "Zresetuj rozmowę",
  },
  debug: {
    resolvedTitle: "Ustalony kontekst",
    listing: "Oferta",
    property: "Obiekt",
    reservation: "Rezerwacja",
    checkin: "Check-in",
    checkout: "Check-out",
    lang: "Język",
    toolsTitle: "Użyte narzędzia",
  },
  chat: {
    emptyPrompt: "Napisz wiadomość jako gość.",
    pay: "Zapłać",
    book: "Zarezerwuj",
    sentAsButton: "Na WhatsAppie wysyłane jest jako przycisk",
    sentAsList: "Na WhatsAppie wysyłane jest jako lista · {button}",
    inputPlaceholder: "Napisz wiadomość…",
  },
  suggestions: {
    s1: "O której godzinie jest check-in?",
    s2: "Czy jest parking?",
    s3: "Czy jest wifi? Jakie jest hasło?",
    s4: "Czy mogę zrobić check-in wcześniej?",
  },
  errors: {
    loadListings: "Nie udało się wczytać ofert.",
    chatError: "Błąd podczas komunikacji z agentem.",
    chatReplyFallback: "⚠️ Nie udało się odpowiedzieć. Sprawdź kontekst lub spróbuj ponownie.",
  },
  methods: {
    listingFallback: "Oferta #{id}",
  },
};
